import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretDown = () => {
  return (
    <g>
      <path d="m1.7438 4.55c-.605 0-.75.35-.3222.7778l5.8006 5.8006a1.1032 1.1032 0 0 0 1.5556 0l5.8006-5.8006c.4278-.4278.2828-.7778-.3222-.7778z" />
    </g>
  );
};

export default withIcon(IconCaretDown);
